const allgeneralpay = { data: [], loading: true };
export const GetAllGeneralPay = (state = allgeneralpay, action) => {
    switch (action.type) {

        case "get_allgeneralpay":
            return {
                data: action.payload,
                loading: action.loading
            }
        default:
            return state;
    }


}
